import { render, staticRenderFns } from "./QuestionPartsPreview.vue?vue&type=template&id=546bfcda&scoped=true&"
import script from "./QuestionPartsPreview.vue?vue&type=script&lang=js&"
export * from "./QuestionPartsPreview.vue?vue&type=script&lang=js&"
import style0 from "./QuestionPartsPreview.vue?vue&type=style&index=0&id=546bfcda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546bfcda",
  null
  
)

export default component.exports